/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Month, PRIVILEGED_EP_CLOSE_FINANCIAL_YEAR, SystemRoleBit } from '@gh/builder-shared-data';
import {
  AbstractSnapshotFormComponent,
  EnumDictionary,
  FormState,
  FormStateBuilder,
  FormStateSnapshot,
  getRouteInitData,
  whenAuRegion,
  whenCreateOrEditMode,
} from '@gh/common-shared';
import { getControlValue } from '@gh/core-ui';
import { last } from 'lodash';
import { WipMasterInfo } from '../../resources/wip.model';
import { BuilderUserContext } from '@gh/builder-shared';

@Component({
  selector:        'gh-wip-master-info',
  template:     require('./wip-master-info.component.html'),
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WipMasterInfoComponent extends AbstractSnapshotFormComponent<WipMasterInfo> implements OnInit {
  // tslint:disable-next-line:no-input-prefix
  @Input() isProduce: boolean;
  // tslint:disable-next-line:no-input-prefix
  @Input() isCurrentFinancialYear: boolean;

  @Output() apply = new EventEmitter<void>();
  @Output() closeEmptyYear = new EventEmitter<void>();

  monthDict: EnumDictionary<Month>;
  isModifyActive: boolean = true;

  get canCloseEmptyYear(): boolean {
    return this.isProduce && !this.isCurrentFinancialYear
      && getControlValue(this.form.group, 'currentMonth') === last(getControlValue(this.form.group, 'months'));
  }

  get isUserSwitched(): boolean {
    return this.userContext.officeView;
  }

  get isCorporateOrMaster(): boolean {
    return this.userContext.hasSystemRole(SystemRoleBit.Corporate)
      || this.userContext.hasSystemRole(SystemRoleBit.Master);
  }

  constructor(
    private route: ActivatedRoute,
    private userContext: BuilderUserContext,
    private formStateBuilder: FormStateBuilder,
    private _changeDetectorRef: ChangeDetectorRef,
  ) {
    super();
  }

  onPrivilegedTokenReceived(): void {
    this.isModifyActive = false;
  }

  ngOnInit(): void {
    const { monthDict } = getRouteInitData(this.route);
    this.monthDict = monthDict;
    super.ngOnInit();
  }

  protected buildForm(snapshot: FormStateSnapshot<WipMasterInfo>): FormState<WipMasterInfo> {
    return this.formStateBuilder.buildPlain({
      mode: this.mode,

      snapshot,
      privilegedEntryPoints: [PRIVILEGED_EP_CLOSE_FINANCIAL_YEAR],
      children:              {
        months:       void 0,
        currentMonth: { required: true, enabled: whenCreateOrEditMode() },
        excludeDpp:   { visible: whenAuRegion() },
      },
    });
  }
}
